import { I18nComponente } from "@/types/gerais"

export const OUsuarioInformacoesi18n: I18nComponente = {
  "pt-BR": {
    nome: "nome",
    codigo: "código",
    usuariosResponsaveis: "Usuários Responsáveis",
    campoObrigatorio: "campo obrigatório"
  },
  "es-CO": {
    nome: "nombre",
    codigo: "código",
    usuariosResponsaveis: "usuarios responsables",
    campoObrigatorio: "campo obligatorio"
  }
}
